/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { RiArrowRightFill } from "react-icons/ri";
import SearchField from "components/fields/SearchField";
import { IoIosCopy } from "react-icons/io";
import { PiQuestionLight } from "react-icons/pi";
import { PiEyeLight } from "react-icons/pi";
import { MdNavigateNext, MdNavigateBefore, MdSkipPrevious, MdSkipNext } from "react-icons/md";
import { FaAngleDown } from "react-icons/fa";
import { useState } from "react";
import { HiOutlineLightBulb } from "react-icons/hi";
import { Link } from "react-router-dom";
import VerifiedIcon from "assets/img/icons/verified.png";
import NftIcon from "assets/img/icons/nft.png";
import Opensea from "assets/img/icons/opensea.png";

const NftCollection = () => {
  const [tabIndex, setTabIndex] = useState(0);

  return (
    <div className="relative">
      {/* Card widget */}
      <div className="header-back-gradient">
        <div className="container py-6">
          <div className="w-full px-2.5 md:px-3 lg:px-5">
            <div className="w-full flex items-center ">
              <div className="md:flex justify-between w-full md:py-6 md:gap-6">
                <div className="md:mb-0 mb-4">
                  <p className="relative text-header text-white mb-3 flex items-center gap-2">
                    Owl Bridge
                    <img
                      width={29}
                      height={29}
                      src={VerifiedIcon}
                      alt=""
                    />
                  </p>
                  <div className="flex gap-[2px] items-center">
                    <div className="truncateWrapper">
                      <span className="text-large truncate mr-1 text-white">
                      BrW3yUL4E3WDtK8Dyy5zvVs1KifxfVjKztvEDNxQhz7b
                      </span>
                    </div>
                    <button className="text-large text-green-600"><IoIosCopy /></button>
                  </div>
                </div>
                <SearchField
                  extra="sm:min-w-[480px] xl:min-w-[650px]"
                  placeholder="Search by Address/ Txn Hash/ Block/ Token/Domain Name"
                  id="email"
                  type="text"
                />
              </div>
            </div>
            <div className="w-full flex text-center mt-3 md:mt-1">
              <div className="ml-auto md:mr-0 mr-auto flex gap-4">
                <button className="btn btn-gray text-xsmall !font-semibold flex items-center">Buy <span className="ml-[1px] text-xs"><FaAngleDown /></span></button>
                <button className="btn btn-gray text-xsmall !font-semibold flex items-center">Exchange <span className="ml-[1px] text-xs"><FaAngleDown /></span></button>
                <button className="btn btn-gray text-xsmall !font-semibold flex items-center">Play <span className="ml-[1px] text-xs"><FaAngleDown /></span></button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="mt-6 md:mt-12 px-2.5 md:px-3 lg:px-5">
          <div className="grid grid-cols-1 lg:grid-cols-11 gap-6">
            <div className="box bg-white dark:bg-darkPrimary px-2.5 md:px-5 py-5 lg:col-span-11 xl:col-span-5">
              <div className="flex flex-col">
                <h1 className="text-large mb-3">Overview</h1>
                <div className="flex gap-6">
                  <img 
                    src={NftIcon}
                    width={110}
                    height={110}
                    className="rounded-[10px]"
                    alt=""
                  />
                  <div className="flex flex-col gap-2.5 grow">
                    <div className="flex justify-between max-w-[260px]">
                      <span className="text-gray-700 dark:text-gray-300">Assets</span>
                      <span className="">3,333</span>
                    </div>
                    <div className="flex justify-between max-w-[260px]">
                      <span className="text-gray-700 dark:text-gray-300">Max Total Suply</span>
                      <div className="flex items-center">
                        <span className="">10,000 BBA</span>
                      </div>
                    </div>
                    <div className="flex justify-between max-w-[260px]">
                      <span className="text-gray-700 dark:text-gray-300">Holders</span>
                      <span className="">1,000</span>
                    </div>
                    <div className="flex justify-between max-w-[260px]">
                      <span className="text-gray-700 dark:text-gray-300">Total transfers</span>
                      <span className="">3,047</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="box bg-white dark:bg-darkPrimary overflow-hidden px-2.5 md:px-5 py-5 lg:col-span-5 xl:col-span-3">
              <div className="flex flex-col gap-3">
                <h1 className="text-large">Market</h1>
                <div className="flex justify-between max-w-[260px]">
                  <span className="text-gray-700 dark:text-gray-300">Volume 24h</span>
                  <span className="">998,121.65 BBA</span>
                </div>
                <div className="flex justify-between max-w-[260px]">
                  <span className="text-gray-700 dark:text-gray-300">Floor Price</span>
                  <div className="flex items-center">
                    <span className="">0.01 BBA</span>
                  </div>
                </div>
                <div className="flex justify-between max-w-[260px]">
                  <span className="text-gray-700 dark:text-gray-300">Min Price (24h)</span>
                  <span className="">0.01 BBA <span className="text-gray-700 dark:text-gray-300">$0.01</span></span>
                </div>
                <div className="flex justify-between max-w-[260px]">
                  <span className="text-gray-700 dark:text-gray-300">Max Price (24h)</span>
                  <span className="">0.01 BBA <span className="text-gray-700 dark:text-gray-300">$0.01</span></span>
                </div>
              </div>
            </div>
            <div className="box bg-white dark:bg-darkPrimary overflow-hidden px-2.5 md:px-5 py-5 lg:col-span-6 xl:col-span-3">
              <div className="flex flex-col gap-3">
                <h1 className="text-large">Other Info</h1>
                <p className="text-gray-700 dark:text-gray-300">Allocated Data Size</p>
                <div className="flex">
                  <div className="truncateWrapper">
                    <Link to="/txs/3FDZVJSFgGcpk5iJMfTPTVDgMwopjKfHYqq3PoZkncFsJWDFPLx9BUWWsmrnFQ2H2CmfxA61gMkrcavSdvbGyv2b" className="text-xsmall truncate">
                      3FDZVJSFgGcpk5iJMfTPTVDgMwopjKfHYqq3PoZkncFsJWDFPLx9BUWWsmrnFQ2H2CmfxA61gMkrcavSdvbGyv2b
                    </Link>
                  </div>
                  <button className="text-gray-900 dark:text-gray-300"><IoIosCopy /></button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={`mt-6 mb-12 px-2.5 md:px-3 lg:px-5`}>
          <div className="box bg-white dark:bg-darkPrimary overflow-hidden px-2.5 md:px-5 py-5">
            <div className="flex gap-2.5">
              <button className={`btn btn-tab ${tabIndex === 0 ? 'active' : ''}`} onClick={() => setTabIndex(0)}>
                Items
              </button>
              <button className={`btn btn-tab ${tabIndex === 1 ? 'active' : ''}`} onClick={() => setTabIndex(1)}>
                Trades
              </button>
              <button className={`btn btn-tab ${tabIndex === 2 ? 'active' : ''}`} onClick={() => setTabIndex(2)}>
                Transfers
              </button>
              <button className={`btn btn-tab ${tabIndex === 3 ? 'active' : ''}`} onClick={() => setTabIndex(3)}>
                Info
              </button>
            </div>
            <div className="flex flex-col mt-5">
              <div className={`w-full ${tabIndex === 0 ? '' : 'hidden'}`}>
                <div className="not-italic text-large mb-3">
                  Latest 10,000 active tokens
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6 gap-1 sm:gap-2.5 xl:gap-6 2xl:gap-9">
                  {
                    Array(18).fill(0).map((data) => <Link to="/nft/1" className="mx-auto rounded-[10px] border border-gray-100 dark:border-lightGrey p-5 hover:shadow-lg cursor-pointer max-w-[196px]">
                      <img
                        src={NftIcon}
                        width="100%"
                        height="auto"
                        className="rounded-[10px] mb-2.5"
                        alt=""
                      />
                      <div className="flex flex-col gap-1">
                        <div className="flex">
                          Token ID:
                          <div className="truncateWrapper ml-1">
                            <p className="text-green-900 text-xsmall truncate">
                              1010
                            </p>
                          </div>
                        </div>
                        <div className="flex">
                          Owner: 
                          <div className="truncateWrapper ml-1">
                            <p className="text-green-900 text-xsmall truncate">
                              3FDZVJSFgGcpk5iJMfTPTVDgMwopjKfHYqq3PoZkncFsJWDFPLx9BUWWsmrnFQ2H2CmfxA61gMkrcavSdvbGyv2b
                            </p>
                          </div>
                          <button className="text-gray-900 dark:text-gray-300 text-xsmall"><IoIosCopy /></button>
                        </div>
                        <div className="flex">
                          Last traded:
                          <div className="truncateWrapper ml-1">
                            <p className="text-green-900 text-xsmall truncate">
                              $0.001(0.01BBA)
                            </p>
                          </div>
                        </div>
                      </div>
                    </Link>)
                  }
                </div>
                <div className="py-5 flex mb-2 w-full">
                  <div className="flex gap-2 ml-auto">
                    <button className="!px-1.5 !py-1 btn-outline !text-xl disabled"><MdSkipPrevious /></button>
                    <button className="!px-1.5 !py-1 btn-outline !text-xl disabled"><MdNavigateBefore /></button>
                    <span className="text-small flex items-center px-2">Page 1 of 25</span>
                    <button className="!px-1.5 !py-1 btn-outline !text-xl"><MdNavigateNext /></button>
                    <button className="!px-1.5 !py-1 btn-outline !text-xl"><MdSkipNext /></button>
                  </div>
                </div>
              </div>
              <div className={`w-full ${tabIndex === 1 ? '' : 'hidden'}`}>
                <div className="not-italic text-large mb-3">
                  Latest 25 NFT Trade Token Transfer Events
                </div>
                <div className="table-wrapper">
                  <table className="table w-full">
                    <thead>
                      <tr className="">
                        <th className="w-[10px] !min-w-0 !pr-0"><a href="#" className="text-large" data-for="txs-tip" data-tip="See preview of Transactions Details"><PiQuestionLight /></a></th>
                        <th className="">Txn Hash</th>
                        <th className="">Block</th>
                        <th className="">Age</th>
                        <th className="">Action</th>
                        <th className="">Price</th>
                        <th className="">Market</th>
                        <th className="">Buyer</th>
                        <th className="">Item</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        Array(4).fill(0).map((data) => <tr>
                          <td className="!pr-0">
                            <a href="#" className="text-large"><PiEyeLight /></a>
                          </td>
                          <td>
                            <div className="flex gap-[1px] max-w-[160px]">
                              <div className="truncateWrapper">
                                <Link to="/txs/3FDZVJSFgGcpk5iJMfTPTVDgMwopjKfHYqq3PoZkncFsJWDFPLx9BUWWsmrnFQ2H2CmfxA61gMkrcavSdvbGyv2b" className="text-green-900 text-small truncate">
                                  3FDZVJSFgGcpk5iJMfTPTVDgMwopjKfHYqq3PoZkncFsJWDFPLx9BUWWsmrnFQ2H2CmfxA61gMkrcavSdvbGyv2b
                                </Link>
                              </div>
                              <button className="text-gray-700 dark:text-gray-300"><IoIosCopy /></button>
                            </div>
                          </td>
                          <td>
                            <p className="text-small text-green-900">109,901,461</p>
                          </td>
                          <td>
                            <p className="text-small ">12 secs ago</p>
                          </td>
                          <td>
                            <p className="text-small text-green-900">Bought</p>
                          </td>
                          <td>
                            <p className="text-small">0.01 BBA</p>
                          </td>
                          <td>
                            <p className="text-small flex items-center gap-1">
                              <img
                                src={Opensea}
                                width={16}
                                height={16}
                              />
                              Opensea
                            </p>
                          </td>
                          <td>
                            <div className="flex gap-[1px] max-w-[160px]">
                              <div className="truncateWrapper">
                                <p className="text-green-900 text-small truncate">0x6d4C3166903a5471</p>
                              </div>
                              <button className="text-gray-700 dark:text-gray-300"><IoIosCopy /></button>
                            </div>
                          </td>
                          <td>
                            <p className="text-green-900 text-small truncate flex items-center gap-1">
                              <img
                                src={NftIcon}
                                className="rounded-1 w-6 h-6 ml-auto"
                                alt=""
                              />
                              Owl Bridge #475
                            </p>
                          </td>
                        </tr>)
                      }
                      
                    </tbody>
                  </table>
                </div>
                <div className="pt-5 justify-center flex w-full">
                  <Link to="#" className="btn-outline text-small flex gap-1">View All NFT Trades<RiArrowRightFill /></Link>
                </div>
              </div>
              <div className={`w-full ${tabIndex === 2 ? '' : 'hidden'}`}>
                <div className="not-italic text-large mb-3">
                  A total of 236,915 transactions found
                </div>
                <div className="table-wrapper">
                  <table className="table w-full">
                    <thead>
                      <tr className="">
                        <th className="w-[10px] !min-w-0 !pr-0"><a href="#" className="text-large" data-for="txs-tip" data-tip="See preview of Transactions Details"><PiQuestionLight /></a></th>
                        <th className="">Txn Hash</th>
                        <th className="">Action</th>
                        <th className="">Block</th>
                        <th className="">Age</th>
                        <th className="">From</th>
                        <th className="">To</th>
                        <th className="">Item</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        Array(4).fill(0).map((data) => <tr>
                          <td className="!pr-0">
                            <a href="#" className="text-large"><PiEyeLight /></a>
                          </td>
                          <td>
                            <div className="flex gap-[1px] max-w-[160px]">
                              <div className="truncateWrapper">
                                <Link to="/txs/3FDZVJSFgGcpk5iJMfTPTVDgMwopjKfHYqq3PoZkncFsJWDFPLx9BUWWsmrnFQ2H2CmfxA61gMkrcavSdvbGyv2b" className="text-green-900 text-small truncate">
                                  3FDZVJSFgGcpk5iJMfTPTVDgMwopjKfHYqq3PoZkncFsJWDFPLx9BUWWsmrnFQ2H2CmfxA61gMkrcavSdvbGyv2b
                                </Link>
                              </div>
                              <button className="text-gray-700 dark:text-gray-300"><IoIosCopy /></button>
                            </div>
                          </td>
                          <td>
                            <p className="text-small text-green-900">Bought</p>
                          </td>
                          <td>
                            <p className="text-small text-green-900">109,901,461</p>
                          </td>
                          <td>
                            <p className="text-small ">12 secs ago</p>
                          </td>
                          <td>
                            <div className="flex gap-[1px] max-w-[160px]">
                              <div className="truncateWrapper">
                                <p className="text-green-900 text-small truncate">3FDZVJSFgGcpk5iJMfTPTVDgMwopjKfHYqq3PoZkncFsJWDFPLx9BUWWsmrnFQ2H2CmfxA61gMkrcavSdvbGyv2b</p>
                              </div>
                              <button className="text-gray-700 dark:text-gray-300"><IoIosCopy /></button>
                            </div>
                          </td>
                          <td>
                            <div className="flex gap-[1px] max-w-[160px]">
                              <div className="truncateWrapper">
                                <p className="text-green-900 text-small truncate">3FDZVJSFgGcpk5iJMfTPTVDgMwopjKfHYqq3PoZkncFsJWDFPLx9BUWWsmrnFQ2H2CmfxA61gMkrcavSdvbGyv2b</p>
                              </div>
                              <button className="text-gray-700 dark:text-gray-300"><IoIosCopy /></button>
                            </div>
                          </td>
                          <td>
                            <p className="text-green-900 text-small truncate flex items-center gap-1">
                              <img
                                src={NftIcon}
                                className="rounded-1 w-6 h-6 ml-auto"
                                alt=""
                              />
                              Owl Bridge #475
                            </p>
                          </td>
                        </tr>)
                      }
                      
                    </tbody>
                  </table>
                </div>
                <div className="pt-5 justify-center flex w-full">
                  <Link to="#" className="btn-outline text-small flex gap-1">View All NFT Transactions<RiArrowRightFill /></Link>
                </div>
              </div>
              <div className={`w-full ${tabIndex === 3 ? '' : 'hidden'}`}>
                <div className="not-italic text-large pb-3 border-b-[1px] border-gray-100 dark:border-lightGrey w-full">
                  Overview
                </div>
                <div className="py-2.5">
                  Owl Bridge starts with a collection of 3,333 avatars that give you membership access to The Garden: a corner of the internet where artists, builders, and web3 enthusiasts meet to create a decentralized future.
                </div>
              </div>
            </div>
          </div>
          <div className={`text-gray-700 dark:text-gray-300 text-xsmall flex items-center mt-5 ${tabIndex === 2 || tabIndex === 3 ? '' : '!hidden'}`}>
            <span className="text-large mr-1 mb-1"><HiOutlineLightBulb /></span>
            <span>
              A token serves as a digital representation of assets, whether they exist on-chain or off-chain. The token overview page provides key details including current price, total supply, number of holders, transfer history, and relevant social media links. Discover more about this page in our guide.
              <span className="text-green-900 ml-1">Knowledge Hub</span>.
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NftCollection;
